import React, {
  useCallback,
} from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { FormattedMessage } from 'react-intl';

import { stripesConnect } from '@folio/stripes/core';

import { useCallout } from '../../hooks';
import {
  getCreateEditJobTemplatePayload,
  removeEmptyLinkage,
} from '../../utils';
import JobTemplateForm from '../../components/job-template/job-template-form';
import {
  JOB_TEMPLATE_FIELDS,
  JOB_TEMPLATE_INITIAL_VALUES,
  getJobTemplatesListUrl,
  getJobTemplatesViewUrl,
} from '../../constants';
import { IfPermissionWrapper } from '../../components/common';

const JobTemplateCreateRoute = ({
  mutator,
  history,
  location,
}) => {
  const showCallout = useCallout();

  const onBack = useCallback(() => {
    history.push({
      pathname: getJobTemplatesListUrl(),
      search: location.search,
    });
  }, [history, location.search]);

  const onSubmit = useCallback((values) => {
    const requestBody = removeEmptyLinkage(getCreateEditJobTemplatePayload(values));

    mutator.createJobTemplate.POST({ ...requestBody })
      .then((response) => {
        showCallout({
          message: <FormattedMessage
            id="ui-task-list.callout.created.jobTemplate"
            values={{ name: response[JOB_TEMPLATE_FIELDS.NAME] }}
          />,
        });
        history.push({
          pathname: getJobTemplatesViewUrl(response[JOB_TEMPLATE_FIELDS.ID]),
          search: location.search,
        });
      })
      .catch(() => {
        showCallout({
          type: 'error',
          message: <FormattedMessage id="ui-task-list.validation.communicationProblem" />,
        });
      });
  }, [showCallout, location.search, history, mutator.createJobTemplate]);

  const getTitle = () => <FormattedMessage id="ui-task-list.title.new.jobTemplate" />;

  return (
    <IfPermissionWrapper perm="ui-task-list.job-template.create-edit">
      <JobTemplateForm
        formTitle={getTitle}
        initialValues={JOB_TEMPLATE_INITIAL_VALUES}
        onBack={onBack}
        onSubmit={onSubmit}
      />
    </IfPermissionWrapper>
  );
};

JobTemplateCreateRoute.manifest = Object.freeze({
  createJobTemplate: {
    type: 'okapi',
    path: 'tasks/job-templates',
    clientGeneratePk: false,
    throwErrors: false,
    fetch: false,
  },
});

JobTemplateCreateRoute.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
  mutator: PropTypes.shape({
    createJobTemplate: PropTypes.shape({
      POST: PropTypes.func.isRequired
    }),
  }),
};

export default stripesConnect(JobTemplateCreateRoute);
